import Common from "../common/Common";
import SessionCheck from "../common/SesionCheck";
import { NETWORK } from "../common/const";

class CommunitySdk {
  constructor() {
    // // eruda 초기화
    // this.setEruda();

    // cnb 생성 시 및 15분 간격으로 인증 확인 API 호출
    new SessionCheck();
  }

  // setEruda() {
  //   if(Common.instance?.env === NETWORK.live || document.querySelector('#eruda')) return;
  //   eruda?.init();
  // }
}

export default CommunitySdk;